<template>
	<div class="risk_detail " :class="status">
		<div class="bg">
			<div class="risk_detail-content">
				<div class="title title2">您属于中风</div>
				<div class="statusText textColor">【 {{statusText[status]}} 】</div>
				<div class="number_row">
					<div class="number_row-item border-right">
						<div class="title">未来{{year}}年患中风的几率</div>
						<div class="proportion">{{obj[year].risk}}<span>%</span></div>
					</div>
					<div class="number_row-item ">
						<div class="title">比同龄同性别健康者高出</div>
						<div class="proportion">{{obj[year].bei}}<span>倍</span></div>
					</div>
				</div>
				<div class="risk_detail-button textColor" @click="changeYear "
					>查看{{year===5?10:5}}年风险结果<van-icon name="arrow"
				/></div>
			</div>
			<div class="risk_detail-disease" v-if="dataList.length>0">
				<div class="label">引发您患中风疾病的危险因素有：</div>
				<div class="disease-item-row">
					<div class="disease-item" v-for="(item,index) in dataList" :key="index">{{item}}</div>
					<div style="clear:both"></div>
				</div>
			</div>
			<foot-button>
				<van-button type="primary" block @click="$emit('back')"> 重新评估 </van-button>
			</foot-button>
		</div>
	</div>
</template>
<script>
export default {
    data () {
        return {
            //    status:'top', 
            statusText: {
                'low': '低危人群',
                'between': '中危人群',
                'top': '高危人群',
                'high': '极高危人群',
            },
            year: 5,
            //    dataList:['左心室肥厚','血压过高','左心室肥厚','左心室肥厚22']
        }
    },
    props: {
        result: {
            type: Object,
            default: () => { }
        }
    },
    computed: {
        dataList () {
            return this.result.arr
        },
        obj () {
            return this.result.obj
        },
        status () {
            let ret = 'top'
            let num = this.obj[this.year].bei
            if (num <= 3.5 && num >= 0) {
                ret = 'low'
            } else if (num <= 7 && num >= 3.6) {
                ret = 'between'
            } else if (num <= 10 && num >= 7.1) {
                ret = 'top'
            } else if (num > 10) {
                ret = 'high'
            }
            return ret
        }
    },
    methods: {
        changeYear () {
            this.year = this.year === 5 ? 10 : 5
        }
    }
}
</script>
<style lang="less" scoped>
.low {
	.bg {
		background-image: url('../../assets/img/bg-01.png');
	}
	.textColor {
		color: @primary;
	}
	.risk_detail-button {
		background: rgba(21, 196, 205, 0.08);
	}
}
.between {
	.bg {
		background-image: url('../../assets/img/bg-02.png');
	}
	.textColor {
		color: #ffc71d;
	}
	.risk_detail-button {
		background: rgba(255, 199, 29, 0.08);
	}
}
.top {
	.bg {
		background-image: url('../../assets/img/bg-03.png');
	}
	.textColor {
		color: #fd751f;
	}
	.risk_detail-button {
		background: rgba(253, 117, 31, 0.08);
	}
}
.high {
	.bg {
		background-image: url('../../assets/img/bg-04.png');
	}
	.textColor {
		color: #ff4f5a;
	}
	.risk_detail-button {
		background: rgba(255, 79, 90, 0.08);
	}
}
.risk_detail {
	.title {
		color: @gray-9;
		font-size: 24px;
		text-align: center;
	}
	.bg {
		overflow: hidden;
		min-height: calc(100vh - 113px);
		padding-top: 113px;
		background-size: 100vw 608px;
		background-repeat: no-repeat;
	}
	&-content {
		border-radius: 32px;
		background-color: #ffffff;
		padding: 40px 32px;
		margin: 0 32px 28px 32px;
		.title2 {
			font-size: 28px;
		}
		.statusText {
			font-size: 64px;
			text-align: center;
			font-weight: bold;
			padding: 54px 0;
		}
	}
	&-button {
		width: 426px;
		height: 62px;
		border-radius: 9px;
		margin: 0 auto;
		font-size: 28px;
		text-align: center;
		line-height: 62px;
	}
	&-disease {
		border-radius: 16px;
		padding: 32px 28px;
		background-color: #ffffff;
		margin: 28px;
		.label {
			font-size: 32px;
			font-weight: bold;
			color: #1f2329;
			margin-bottom: 40px;
		}
		.disease-item-row {
			width: 645px;
		}
		.disease-item {
			height: 72px;
			line-height: 72px;
			background: #f6f8fa;
			border-radius: 12px;
			color: 28px;
			min-width: 166px;
			text-align: center;
			margin-right: 15px;
			padding: 0 16px;
			float: left;
			margin-bottom: 24px;
		}
	}
	.number_row {
		padding: 24px 0;
		display: flex;
		border-top: 1px solid #eaeaea;
		&-item {
			flex: 1;
			.proportion {
				font-size: 34px;
				vertical-align: bottom;
				text-align: center;
				height: 90px;
				line-height: 90px;
				span {
					font-size: 28px;
				}
			}
		}
		.border-right {
			border-right: 1px solid #eaeaea;
		}
	}
}
</style>